import * as React from "react";
import { SVGProps } from "react";

export const SearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 14 14" fill="none" {...props}>
    <path
      stroke={props.color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M5.893 10.787a4.893 4.893 0 1 0 0-9.787 4.893 4.893 0 0 0 0 9.787ZM13 13 9.546 9.548"
    />
  </svg>
);
export default SearchIcon;
